<div class="modal message-modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content" [ngClass]="getBorderState()">
            
            <div class="row message-modal-content pb-2">
                <div class="col-sm-2">
                    <div [ngClass]="getIconClass()"></div>
                </div>

                <div class="col-xs-10 pt-1 pr-0 pl-0">
                    <div class="modal-title pb-2" [innerHTML]="title"></div>
                    <span class="modal-message" [innerHTML]="message"></span>
                    <span class ="modal-countdown" *ngIf="timerCountNeeded()">&nbsp;{{ timeCount }}</span>
                </div>
            </div>
            <div class="modal-footer">
                <div class="btn-group-lg-align-center">
                    <button type="button"
                            class="message-button btn-lg message-modal-button-text"
                            *ngIf="!!buttonOneObj"
                            (click)="confirmButtonClick('one')"
                            [ngClass]="{'single-message-button' : !(buttonOneObj && buttonTwoObj), 
                            'primary-button' : (iconClass === 'pic-complete' || timer),
                            'secondary-button' : (iconClass !== 'pic-complete' && !timer)}">{{ buttonOneObj.text }}
                    </button>
                    <button type="button"
                            class="message-button message-button-two btn-lg message-modal-button-text"
                            data-dismiss="modal"
                            *ngIf="!!buttonTwoObj"
                            (click)="confirmButtonClick('two')"
                            [ngClass]="(iconClass !== 'pic-complete' && !timer ) ? 'primary-button' : 'secondary-button'">{{ buttonTwoObj.text }}
                    </button>          
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>